import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 py-12">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          <div>
            <img
              src="/logo/stampfit-logo-light.png"
              alt="StampFit"
              className="w-[190px] mb-4"
            />
            <p className="text-white/70 text-sm">
              피트니스 지도자 자격 인증 및 구인구직 통합 플랫폼
            </p>
            <div className="flex gap-4 mt-4 text-sm">
              <Link to="/legal/terms" className="text-white/70 hover:text-white transition-colors underline">
                이용약관
              </Link>
              <Link to="/legal/privacy" className="text-white/70 hover:text-white transition-colors underline">
                개인정보처리방침
              </Link>
              <Link to="/legal/refund" className="text-white/70 hover:text-white transition-colors underline">
                환불 정책
              </Link>
            </div>
          </div>
          <div className="text-sm text-white/70 space-y-1">
            <p>상호: 스탬프 핏(STAMP FIT) | 대표자: 박원범</p>
            <p>사업자 등록번호: 291-19-02120 | 통신판매업신고번호: 2026-화성만세-0125 호</p>
            <p>사업장 소재지: 경기도 화성시 만세구 향남읍 상신하길로298번길 7-23, 803호</p>
            <p>전화: 010-2911-0613 | 문의: admin@stamp-fit.com</p>
            <p className="mt-2">© 2026 StampFit. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
